import { all, call, put, select, takeEvery } from "redux-saga/effects";

import {
  getProgramsFailed,
  getProgramsStart,
  getProgramsSuccess,
} from "../redux/getPrograms";

import { getProgramsApi } from "core/http/service/internalEvents";

import { controlInfinitiveScrollSelector } from "components/common/ListInfinitiveScrolling/redux/selector";

function* getProgramsWork(action: ReturnType<typeof getProgramsStart>) {
  const { offset, limit } = yield select(controlInfinitiveScrollSelector(null));

  try {
    const res = yield call(getProgramsApi, {
      offset,
      limit,
      eventId: action.payload.eventId,
    });
    yield put({
      type: getProgramsSuccess.type,
      payload: {
        data: res.data,
      },
    });
  } catch (error: any) {
    yield put({
      type: getProgramsFailed.type,
    });
  }
}

function* watchGetPrograms() {
  yield takeEvery(getProgramsStart.type, getProgramsWork);
}

export default function* getProgramsSaga() {
  yield all([watchGetPrograms()]);
}
